// функция открытитя формы с ответом, принимает заголовок и сообщение
const openFormStatus = (header, msg) => {

  // устанавливаем зоголовок и сообщение формы
  $('#formStatusHeader').html(header);
  $('#formStatusMsg').html(msg);

  // cкроллинг к началу страницы на мобильных
  if ($(document).width() < 769) {
    $('html, body').animate({scrollTop: 0}, 10);
  }

  // показываем форму
  $('#statusModalOverlay, #statusModal').show();

  $('#closeFormStatus, #statusModalOverlay').click(function () {
    $('#statusModalOverlay, #statusModal').hide();
  });

  // Начинаем слушать клавишу Esc. При её нажатии, закарываем окно.
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      $('#statusModalOverlay, #statusModal').hide();
    }
  });
};

export default openFormStatus;





// WEBPACK FOOTER //
// ./app/blocks/form/form.js